export default __webpack_public_path__ + "static/media/Td.476fd4cb.png";